/**
 * Utility functions for string manipulation
 */

/**
 * Ellipsizes the center of a string, keeping the beginning and end visible
 * @param str - The string to ellipsize
 * @param maxLength - Maximum length of the result (default: 10)
 * @returns The ellipsized string
 */
export const ellipsizeCenter = (str: string, maxLength: number = 10): string => {
  if (str.length <= maxLength) {
    return str;
  }
  
  const startLength = Math.ceil((maxLength - 3) / 2);
  const endLength = Math.floor((maxLength - 3) / 2);
  
  return `${str.slice(0, startLength)}...${str.slice(-endLength)}`;
};

export const formatLargeNumber = (value: string | number, decimals: number = 18): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  if (num >= 1000000) {
    return (num / 1000000).toFixed(2) + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(2) + 'K';
  } else {
    return num.toFixed(2);
  }
};
